<template>
  <span class="terms__agree">
    <CheckboxComponent :checked="checked" @change="$emit('change', !checked)">
      <span>
        Согласен с
        <a
          href="/static/documents/1_Политика_конфиденциальности.pdf"
          target="_blank"
          >политикой обработки персональных данных</a
        >.
      </span>
    </CheckboxComponent>
  </span>
</template>

<script>
import CheckboxComponent from "components/inputs/CheckboxComponent.vue";
export default {
  name: "TermsAgreeCheckboxComponent",
  components: { CheckboxComponent },
  model: {
    prop: "checked",
    event: "change",
  },
  props: {
    checked: Boolean,
  },
  data() {
    return {
      agree: false,
    };
  },
};
</script>

<style lang="stylus">
.terms__agree {
  margin-top: 10px;
  color var(--main-color)
  display flex
  font-size: 0.75em
  line-height: 18px;
  gap 5px

  .check {
    align-items center
    &:hover {
      a {
        color var(--main-color-75)
      }
    }
  }
  a {
    text-decoration underline
		color var(--main-color)
  }

}
</style>
